import { productApiUrl } from "API/urls/product.api";
import { axiosInstance } from "configs/axios";

export const updatePmcChecklistApi = async (formData) => {
  try {
    const response = await axiosInstance.post(
      productApiUrl.pmcChecklistUpdate,
      {
        ...formData,
      }
    );
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
